import Image from "next/image";
import Layout from "../components/Layouts";
import Nav from "../components/Navi";
import Footer from "../components/Footers";
import React from "react";
import styles from "../styles/host-country-media-accreditation.module.scss";
// import ExploreMore from "../components/ExploreMore/hostCountryMediaAccreditation";
import ExploreMore from "../components/ExploreMore/hostCountryMedia";
import CountdownBar from "../components/CountdownBar";
import SocialMedia from "../components/SocialMedia";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
export default function HostCountryMediaAccreditation() {
  const { t } = useTranslation("common");
  React.useEffect(() => {
    import("lottie-interactive/dist/lottie-interactive.js");
  });
  return (
    <>
      <section className={`banner d-flex align-items-center position-relative`}>
        <div className={`${styles.bannerWrapper} d-none d-md-block`}>
          <Image
                src="/assets/images/explore-by-bus.jpg"
                alt="host-country-accreditation-img"
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className={`${styles.bannerWrapper} d-block d-md-none`}>
          <Image
            src="/assets/images/banners/mobile/Host-Country-Accreditation.jpg"
            alt="host-country-accreditation-img"
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className="container contentSection position-relative my-auto">
          <div className="text-start">
            <h1 className="text-light banner-heading" style={{"width": "fit-content"}}>
{t("aboutqatarheading")}
            </h1>
          </div>
        </div>
      </section>
      <section className={`${styles.content} bg-yellow-section pt-sm-3 pb-sm-2`}>
      <section >
            <div className=" pt-3 pb-3">
                <div className="container pb-sm-5 mt-sm-5 mt-1">
                    <div className="row">
                        <h2>  {t("generalinfotitle")}</h2>
                        <ul>
                            <li>{t("generalinfo-1")}</li>
                            <li>{t("generalinfo-2")}</li>
                            <li>{t("generalinfo-3")}</li>
                            <li>{t("generalinfo-4")}</li>
                            <li>{t("generalinfo-5")}</li>
                        </ul>

                        <h2>{t("climatetitle")}</h2>
                        <p>{t("climateparagraph")}</p>
                        <h2>{t("foodtitle")}</h2>
                        <p>{t("foodparagraph-1")}<br />{t("foodparagraph-2")}</p>
                        <h2>{t("transporttitle")}</h2>
                        <p>{t("transportparagraph-1")}  <br /> {t("transportparagraph-2")}</p>
                        <h2>{t("safetytitle")}</h2>
                        <p>{t("safetyparagraph-1")} <br />{t("safetyparagraph-2")}  </p>
                    </div>
                </div>
            </div>
        </section>
      </section>
      {/* <section className={`${styles.apply}    pt-4 pb-5`}> */}
        {/* <div className="container my-sm-5">
          <h2 className="page-title-x has-diamonds-x sect-heading pt-4"> {t("importantnotes")}</h2>
          <div className="py-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="190" height="10" viewBox="0 0 190 10" fill="none"><path d="M0.669873 5L5 9.33013L9.33013 5L5 0.669873L0.669873 5ZM5 5.75H190V4.25H5V5.75Z" fill="#222222"></path></svg></div>
          <div className="row pb-5 pt-sm-3 pt-1 diamond-bullets-row-x fw-medium ff-qatar2022 text-burgundy-x">
            <div className="col-12 pb-sm-0 pb-4 d-flex" >
            <div><svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
  <path d="M16 0L21.0912 10.227L32 15L21.0912 19.773L16 30L10.9088 19.773L0 15L10.9088 10.227L16 0Z" fill="#D5CC65"/>
</svg></div><p className="px-3 mb-5">{t("importantnotes1")}</p>
            </div>
            <div className="col-12 pb-sm-0 pb-4 d-flex" >
            <div><svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
  <path d="M16 0L21.0912 10.227L32 15L21.0912 19.773L16 30L10.9088 19.773L0 15L10.9088 10.227L16 0Z" fill="#D5CC65"/>
</svg></div><p className="px-3 mb-5">{t("importantnotes8")}</p>
            </div>
            <div className="col-sm-9 col-12 pb-sm-0 pb-4 d-flex">
             <div><svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
  <path d="M16 0L21.0912 10.227L32 15L21.0912 19.773L16 30L10.9088 19.773L0 15L10.9088 10.227L16 0Z" fill="#D5CC65"/>
</svg></div><p className="px-3 mb-5">{t("importantnotes2")}</p>
            </div>
            <div className="col-sm-9 col-12 pb-sm-0 pb-4 d-flex">
            <div><svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
  <path d="M16 0L21.0912 10.227L32 15L21.0912 19.773L16 30L10.9088 19.773L0 15L10.9088 10.227L16 0Z" fill="#D5CC65"/>
</svg></div><p className="px-3 mb-5">{t("importantnotes3")}</p>
            </div>

            <div className="col-sm-9 col-12 pb-sm-0 pb-4 d-flex">
            <div><svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
  <path d="M16 0L21.0912 10.227L32 15L21.0912 19.773L16 30L10.9088 19.773L0 15L10.9088 10.227L16 0Z" fill="#D5CC65"/>
</svg></div><p className="px-3 mb-5"> {t("importantnotes4")}</p>
            </div>
            <div className="col-sm-9 col-12 pb-sm-0 pb-4 d-flex">
            <div><svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
  <path d="M16 0L21.0912 10.227L32 15L21.0912 19.773L16 30L10.9088 19.773L0 15L10.9088 10.227L16 0Z" fill="#D5CC65"/>
</svg></div> <p className="px-3 mb-5">
                {t("importantnotes5")}
                <ul className="ps-sm-5 pt-4">
                  <li>{t("importantnotes5-1")}</li>
                  <li> {t("importantnotes5-2")}</li>
                  <li>{t("importantnotes5-3")}</li>
                </ul>
              </p>
            </div>
            <p className="mt-5 pt-5">{t("importantnotes6")}</p>
            <p>
              {t("importantnotes7")}
              <a
                href="mailto:hcmeo@sc.qa"
                className="text-decoration-underline"
              >
                {t("importantnotes7-1")}
              </a>
              {t("importantnotes7-2")}
            </p>
          </div>
        </div> */}
      {/* </section> */}

      {/* <SocialMedia
        Color="#8a1538"
        colNumber="col-md-4 col-12"
        font="ff-qatar2022 fs-5"
        fontWeight="fw-medium"
        textColor="text-burgundy"
        background="bg-light-grey"
      />
      <CountdownBar /> */}
      <ExploreMore />
    </>
  );
}

HostCountryMediaAccreditation.getLayout = function getLayout(page) {
  return (
    <Layout>
      <Nav />
      {page}
      <Footer />
    </Layout>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}


// export default function ExploreMore() {
//     React.useEffect(() => {
//         import("lottie-interactive/dist/lottie-interactive.js");
//     });
//     const { t } = useTranslation("common");
//     return (
        // <section >
        //     <div className=" pt-3 pb-3">
        //         <div className="container pb-sm-5 mt-sm-5 mt-1">
        //             <div className="row">
        //                 <h2>   General Info</h2>
        //                 <ul>
        //                     <li>Capital city: Doha</li>
        //                     <li>Population: 2.7 million </li>
        //                     <li>Population: 2.7 million </li>
        //                     <li>Currency: Qatari riyal (QAR 1 = USD $0.27)</li>
        //                     <li>Official language: Arabic (English is widely spoken)</li>
        //                     <li>International dialing code: +974</li>
        //                 </ul>

        //                 <h2>Climate</h2>
        //                 <p>The average temperature in November / December (winter) is 18C-24C (64F-75F) and in June / July (summer) is 29C-39C (84F-103F). The rest of the year's tempratures are an average of the tempertatures of the winter & summer.
        //                 </p>
        //                 <h2>Food</h2>
        //                 <p>Qatar has extensive international cuisine options and a host of food delivery services. All food in Qatar is halal compliant & most restaurants offer vegetarian options. Local traditional dishes include machboos, harees, thareed, saloona, madrouba, and luqaimat. Different dishes may be offered at different times of the year.
        //                     <br />
        //                     Restaurant prices vary depending on location and type of resturant. Most major credit/debit cards are accepted across Qatar. Only Qatari Riyals are accepted, if paying with cash.
        //                 </p>
        //                 <h2>Transport</h2>
        //                 <p> Qatar’s compact nature means visitors will always be in the thick of the action and never far from an official site  or a tourist attraction.
        //                     Transport is cheap and plentiful across the country. Day passes on the Doha Metro cost QAR 6 (US$ 1.65) following the one-off purchase of a QAR 10 (US$ 2.75) charge card. The Doha Metro is  directly connected to Hamad International Airport, the main hub for visitors travelling to Qatar.
        //                     <br />
        //                     Taxis are plentiful and competitively priced, with multiple ride hailing apps available in Qatar.  Tourist areas such as Msheireb Downtown Doha and Lusail both have light rail tram systems. Visitors wishing to drive from neighbouring countries can enter Qatar via the Salwa border crossing in Saudi Arabia.
        //                 </p>
        //                 <h2>Safety</h2>
        //                 <p>Qatar benefits from one of the lowest crime rates in the world. In January 2022, Qatar maintained its position as the ‘safest country’ in the world, according to the Numbeo Crime Index.
        //                     <br />
        //                     For the FIFA World Cup 2022, Qatar had partnered with some of the most experienced security forces in the world, ad had successfully delivered one of the safest & most secure sporting events.
        //                 </p>
        //             </div>
        //         </div>
        //     </div>
        // </section>
//     );
// }
